import {
  FormatListNumbered,
  PlaylistAddCheck,
  RequestPage,
  SvgIconComponent,
} from "@mui/icons-material";

import { BulkGridSelectionModeEnum } from "@ryde/shared";

export const bulkGridSelectionModeIconMap: Record<
  BulkGridSelectionModeEnum,
  SvgIconComponent
> = {
  [BulkGridSelectionModeEnum.All]: PlaylistAddCheck,
  [BulkGridSelectionModeEnum.Page]: RequestPage,
  [BulkGridSelectionModeEnum.Rows]: FormatListNumbered,
};
